import React from 'react'
import PropTypes from "prop-types";
import Config from 'Config'
import axios from 'axios'
import UniqID from 'uniqid'

class Header extends React.Component {

   constructor() {
      super()
      this.state = {
         data: [],
         slideIndex: 0,
         slideInterval: 0,
      }
   }

   static propTypes = {
      isSmallHeader: PropTypes.bool
   };

   componentDidMount() {
      this.getData();
   }

   getData() {

      axios.get(Config().endpoints.api + "/slideshow")
         .then(response => {
            if (response.data) {
               this.setState({
                  data: response.data
               });
               this.startInterval();
            }
         })
         .catch((error) => {})
   }

   startInterval() {
      var slideInterval = setInterval(this.nextSlide.bind(this), 7000);
      this.setState({
         slideInterval: slideInterval
      });
   }

   clearInterval() {
      clearInterval(this.state.slideInterval);
   }

   nextSlide() {
      var slideIndex = this.state.slideIndex;

      if (slideIndex === (this.state.data.length - 1)) {
         slideIndex = 0;
      } else {
         slideIndex++;
      }

      this.setState({
         slideIndex: slideIndex
      });
   }

   goToSlide(index) {
      this.setState({
         slideIndex: index
      });

      clearInterval(this.state.slideInterval);
      this.startInterval();
   }

   render() {

      const pagination = this.state.data.map((item, idx) =>
         <li
            key={UniqID().toString()}
            className={idx === this.state.slideIndex ? "active" : ""}
            onClick={idx !== this.state.slideIndex ? this.goToSlide.bind(this, idx) : null}
         >
         </li>
      );

      const images = this.state.data.map((item, idx) =>
         <img
            key={"slide_" + idx}
            className={idx === this.state.slideIndex ? "active" : ""}
            src={item}
            alt=""
         >
         </img>
      );

      return (<div id="head-container" className={this.props.isSmallHeader ? "small" : "large"}>
         <div id="head-pagination">
            <ul>
               {pagination}
            </ul>
         </div>
         <div id="head-slides">
            {images}
         </div>
      </div>);
   }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js